import { HttpResponse } from '@angular/common/http';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FileDownloadService } from '@services/file-download.service';
import { ListarPedidosService } from '@services/listar-pedidos.service';
import { FilenameParser } from '@utils/FilenameParser';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CamelCasePipe } from '../../../pipes/camel-case.pipe';
import { AppDatePipe } from '../../../pipes/app-date.pipe';

@Component({
    selector: 'app-resumo',
    templateUrl: './resumo.component.html',
    styleUrls: ['./resumo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CamelCasePipe, AppDatePipe]
})
export class ResumoComponent {

  @Input() dadosResumo: any;
  @Input() pedidoPapel: boolean;

  constructor( 
    private readonly listarPedidosService : ListarPedidosService, 
    private readonly Toastr: ToastrService 
  ) { }

  gerarArquivoFolha( idPedido: number ) {

    this.Toastr.info('Realizando download do arquivo folha');

    this.listarPedidosService.gerarArquivoFolha(idPedido)
    .pipe(take(1))
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        this.Toastr.clear();
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Contrato.pdf',
        );
        FileDownloadService.download([body], filename);
      },
      error: (error) => {
        this.Toastr.clear();
        this.Toastr.error('Erro ao baixar o arquivo folha, por favor tente mais tarde.');
      }
    });
  }
}
